import home from './home';
import dashboard from './dashboard';
import contact from './contact';
// import contactlist from './contactlist';
// import group from './group';
// import organizations from './organizations';
// import designations from './designations';
// import professions from './professions';
import users from './users';
import sms from './sms';
import task from './task-management';
const menuItems = {
  items: [home,dashboard,contact,task,users,sms] // contactlist,group,organizations,designations,professions,
};

export default menuItems;
